$(function () {
    var auth = ycgame.auth;

    // 登录
    $(".lv1-content-btn input, .lv2-content li input, .lv3-url-top-btn").click(function (e) {

        //获取当前时间
        var date = new Date();
        var now = date.getTime();

        //设置截止时间
        var str="2019/4/23 13:00:00";
        var endDate = new Date(str);
        var end = endDate.getTime();

        //时间差
        var leftTime = end-now;

        if (leftTime>0) {
            $(".hint-window").fadeIn("fast", function () {
                $(".hint-window-text").html("活动将于4月23日13:00开启，精彩敬请期待！")
            });
        }else {
            if (! auth.member) {
                $.ycUserDialogOpen();
                e.stopImmediatePropagation();
            }
        }

    });
    $(".hint-window-btn").click(function () {
        $(".hint-window-text").html("");
        $(".hint-window").hide();
    });


    auth.bind( auth.EVENTS.LOGOUT, function () {
        sessionStorage.removeItem('markId');
        sessionStorage.removeItem("id");
        sessionStorage.removeItem("regional");
        location.reload();
    });

    auth.checkLogin();

    auth.bind( auth.EVENTS.LOGIN, function () {
        role();

        $(".lv1-content-btn input").attr('disabled', true).click(function () {
            $(".open-notice-text").html("领取折扣券后，再无法参与活动获得额外折扣，是否领取当前折扣券？");
            $(".open-notice").show();
        });

        $(".open-notice-btn-left").click(function () {
            cashRewards();
        });
        $(".open-notice-btn-right").click(function () {
            $(".open-notice-text").html("");
            $(".open-notice").hide();
        });

        // 任务兑换
        $(".lv2-content li input").attr('disabled', true).click(function () {
            var id = $(this).attr("data-id");
            task(id);
        });

        // 复制链接
        $("#lv3-clip-button").click(function () {
            $(".hint-window").fadeIn("fast", function () {
                $(".hint-window-text").html("复制成功，请分享链接给老朋友吧！")
            });
            var inputText = $("#lv3-summon-text");
            inputText.select();
            document.execCommand("Copy");
        });

        $(".hint-window-btn").click(function () {
            $(".hint-window-text").html("");
            $(".hint-window").hide();
        });

    });

    // 初始化获取用户信息
    function role() {
        var userDataUrl = 'http://act-api.bos.ycgame.com/new-spring-2019/discount/players';
        $.ajax({
            type: "GET",
            url: userDataUrl,
            xhrFields: {
                withCredentials: true
            }
        }).done(function (data) {
            $(".login-username i").html(data.character);
            var regional = sessionStorage.getItem("regional");
            if (regional) {
                $(".login-regional i").html(regional);
            } else {
                if (data.area == "ces3"){
                    $(".login-regional i").html("铁甲雄兵");
                } else if (data.area == "tj04") {
                    $(".login-regional i").html("兵临城下");
                }
            }

            $(".login ").css({
                "opacity":1
            });

            $(".lv1-discount-left-icon-on1").html("-" + data.incDiscount);
            if (data.decDiscount == 100){
                $(".lv1-discount-right-num i").html("0折");
            } else {
                $(".lv1-discount-right-num i").html(data.decDiscount/10 + "折");
            }
            $(".lv3-url-end-size i").html(data.members);

            if (data.isExchange){
                $(".lv1-content-btn input").addClass('active');
            } else {
                $(".lv1-content-btn input").removeAttr("disabled");
            }

            $(".lv2-content li input").removeAttr("disabled");

            $(".lv3-url-end, .lv3-qr-code").show();

            var url = "http://bos.ycgame.com/hd/1904hykj/invitations.html?a=" + data.character +"&b="+ data.id;
            $("#lv3-summon-text").val(encodeURI(url));
            $(".lv3-url-top-text span").html(encodeURI(url));

            var qrCode = new QRCode("qr-code");
            function makeCode(){
                var elText = document.getElementById("lv3-summon-text");
                qrCode.makeCode(elText.value);
            }
            makeCode();

            data.hasActions.forEach(function (value) {
                $(".dataId" + value).attr("disabled", true).addClass("active");
            })


        }).fail(function (xhr) {
            $(".regional-user, .username-user").html("");
            var markId = sessionStorage.getItem('markId');
            if (xhr.responseJSON.code == "choose character") {
                userData();
            } else {
                $(".login-out").click();
                return false;
            }

        })
    }


    // 获取当前账号所在大区信息
    function userData() {
        var userDataUrl = 'https://act-api.bos.ycgame.com/game/characters';
        $.ajax({
            type: "GET",
            url: userDataUrl,
            xhrFields: {
                withCredentials: true
            }
        }).done(function (data) {
            var dataArr = data.data;
            openRegional();
            // 产生大区
            dataArr.forEach(function (item) {
                $(".regional-user").append("<p data-id=" + item.id + ">" + item.name + "</p>")
            });

            $(".lv1-tab input").removeAttr('disabled');

            $(".regional-user p").click(function () {

                var id = $(this).attr("data-id");

                dataArr.forEach(function (item) {

                    if (item.id == id && item.characters.length != 0) {
                        var dataArea = item.id;
                        $.each(item.characters, function (index, value) {
                            $(".username-user").append("<p data-id=" + value.dbid + " data-lv=" + value.level + " data-area="+ dataArea +">" + value.name + "</p>");
                        })
                    } else if (item.id == id && item.characters.length == 0) {
                        $(".username-user").append("<p style='color: red'>该区未创建角色！</p>");
                        setTimeout(function () {
                            $(".login-out").click();
                        },2000);
                    }
                });

            });

        }).fail(function (xhr) {
            alert("请求超时，请稍后再试！");
            $(".login-out").click();
            return false;
        })
    }

    // 确认绑定账户信息
    function electUser(id,area) {

        $.ajax({
            type: "POST",
            url: "http://act-api.bos.ycgame.com/new-spring-2019/choose-character/all",
            data: {"dbid": id, "area": area},
            xhrFields: {
                withCredentials: true
            }
        }).done(function () {
            role();
        })
    }

    // 兑换奖励
    function cashRewards() {
        var url = "http://act-api.bos.ycgame.com/new-spring-2019/discount/exchange";
        $.ajax({
            type: "POST",
            url: url,
            xhrFields: {
                withCredentials: true
            }
        }).done(function (data) {

            $(".open-notice").fadeOut("fast",function () {
                $(".open-notice-text").html("");
                $(".hint-window").fadeIn("fast", function () {
                    $(".hint-window-text").html("领取成功！")
                });
                $(".lv1-content-btn input").addClass('active');
            });

        }).fail(function (xhr) {

            $(".open-notice").fadeOut("fast",function () {
                $(".open-notice-text").html("");
                $(".lv1-content-btn input").removeAttr("disabled");

                if (xhr.status == 403 && xhr.responseJSON.code == "has") {
                    $(".hint-window").fadeIn("fast", function () {
                        $(".hint-window-text").html("已领取过了，不能重复操作！")
                    })
                }else if (xhr.status == 403 && xhr.responseJSON.code == "false") {
                    $(".hint-window").fadeIn("fast", function () {
                        $(".hint-window-text").html("尚未获得过折扣，无法领取！")
                    })
                }else if (xhr.status == 403 && xhr.responseJSON.detail == "服务器繁忙，请稍后再试！") {
                    $(".hint-window").fadeIn("fast", function () {
                        $(".hint-window-text").html("兑换异常，请稍后再试！")
                    })
                }else if (xhr.status == 403 && xhr.responseJSON.detail == "活动尚未开始") {
                    $(".hint-window").fadeIn("fast", function () {
                        $(".hint-window-text").html("活动尚未开始！")
                    })
                } else if (xhr.status == 403 && xhr.responseJSON.detail == "活动已结束") {
                    $(".hint-window").fadeIn("fast", function () {
                        $(".hint-window-text").html("活动已结束！")
                    })
                } else if (xhr.status == 401) {
                    role();
                }
            });
        })
    }

    //任务兑换
    function task(id){
        var url = "http://act-api.bos.ycgame.com/new-spring-2019/discount/actions/" + id;
        $.ajax({
            type: "POST",
            url: url,
            xhrFields: {
                withCredentials: true
            }
        }).done(function (data) {
            role();
            $(".hint-window").fadeIn("fast", function () {
                $(".hint-window-text").html("领取成功！")
            });
            $(".lv2-content li input").removeAttr("disabled");
        }).fail(function (xhr) {
            $(".lv2-content li input").removeAttr("disabled");
            if (xhr.status == 403 && xhr.responseJSON.code == "has") {
                $(".hint-window").fadeIn("fast", function () {
                    $(".hint-window-text").html("已领取过了，不能重复操作！")
                })
            }else if (xhr.status == 403 && xhr.responseJSON.code == "false") {
                $(".hint-window").fadeIn("fast", function () {
                    $(".hint-window-text").html("任务尚未完成，无法领取！")
                })
            }else if (xhr.status == 403 && xhr.responseJSON.detail == "活动尚未开始") {
                $(".hint-window").fadeIn("fast", function () {
                    $(".hint-window-text").html("活动尚未开始！")
                })
            } else if (xhr.status == 403 && xhr.responseJSON.detail == "活动已结束") {
                $(".hint-window").fadeIn("fast", function () {
                    $(".hint-window-text").html("活动已结束！")
                })
            } else if (xhr.status == 401) {
                role();
            }
        })
    }




    // 大区选择
    var $regional;
    $regional = $('.regional');
    $regional.on('click', '.regional-user p', function () {
        closeRegional();
        openUser();
        sessionStorage.setItem("regional",$(this).html());
        $(".login-regional i").html($(this).html());
    });

    function openRegional(id, cb) {
        var layerId = layer.open({
            type: 1,
            shade: 0.5,
            title: false, //不显示标题
            content: $regional, //捕获的元素，注意：最好该指定的元素要存放在body最外层，否则可能被其它的相对元素所影响
            closeBtn: false,
            maxWidth: 'auto'
        });

        $regional.data('layer', layerId);
        $regional.find('.' + id).show().siblings().hide();

        cb && cb.call($regional);
    }

    function closeRegional() {
        layer.close($regional.data('layer'));
    }

    // 角色选择
    var $user;
    $user = $('.username');
    $user.on('click', '.username-user p', function () {
        closeUser();
        $(".login ").css({
            "opacity":1
        });

        $(".login-username i").html($(this).html());
        var dbid = $(this).attr("data-id");
        var area = $(this).attr("data-area");
        electUser(dbid,area);

        sessionStorage.setItem('id',dbid);
        sessionStorage.setItem('markId', $(this).html());
    });

    function openUser(id, cb) {
        var layerId = layer.open({
            type: 1,
            shade: 0.5,
            title: false, //不显示标题
            content: $user, //捕获的元素，注意：最好该指定的元素要存放在body最外层，否则可能被其它的相对元素所影响
            closeBtn: false,
            maxWidth: 'auto'
        });

        $user.data('layer', layerId);
        $user.find('.' + id).show().siblings().hide();

        cb && cb.call($user);
    }

    function closeUser() {
        layer.close($user.data('layer'));
    }

});


//////////////////
// WEBPACK FOOTER
// ./index.js
// module id = 1
// module chunks = 1